import React, { ReactElement } from 'react'

export const renderHTML = (input: string | undefined): ReactElement => {
  if (!input) return <div />
  // eslint-disable-next-line react/no-danger
  const result = <div dangerouslySetInnerHTML={{ __html: input }} />
  return result
}
